<div class="p-16 clickable row subject-item list-item" (click)="select();" (dblclick)="edit()" [ngClass]="{'selected':selected, 'marker':markers && (markers.length>0)}">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p">
            <div fxLayout="row" fxLayoutAlign="start center" class="list-content">
                <div *ngIf="(!selected) || (!allowSelect)" class="avatar" [style.background-color]="_subjectLink?.linkedSubject?.subjectType?.color"
                text-contrast [backgroundColor]="_subjectLink?.linkedSubject?.subjectType?.color">{{_subjectLink?.linkedSubject?.subjectType?.name[0]}}</div>
                <div *ngIf="selected && allowSelect">
                    <mat-icon class="avatar checked" text-contrast [backgroundColor]="_subjectLink?.linkedSubject?.subjectType?.color">done</mat-icon>
                </div>
                <div class="item">
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <div class="h3 text-truncate">{{_subjectLink?.linkedSubject?.summary || _subjectLink?.linkedSubject?.reference}}</div>
                    </div>
                    <div *ngIf="_subjectLink?.primaryLink" class="w-100-p">
                      <span class="secondary-text text-truncate">{{_subjectLink?.primaryLink}}</span>
                    </div>
                    <div *ngIf="_subjectLink?.secondaryText || _subjectLink?.relationship" class="w-100-p">
                        <span class="secondary-text text-truncate">{{_subjectLink?.secondaryText || _subjectLink?.relationship?.name}}</span>
                    </div>
                </div>
            </div>
            <div class="buttons" fxLayout="row wrap" fxLayoutAlign="flex-end center" style="margin-left: 12px;">
                <div *ngIf="markers && (markers.length>0)" id="markers" [ngClass]="{'hide-on-hover':(canEdit || canDelete) && (!readOnly)}" style="display: flex;">
                    <mat-icon class="marker-icon" *ngFor="let subjectMarker of markers" [style.color]='subjectMarker.marker?.color' [matTooltip]="subjectMarker.marker?.name">room</mat-icon>
                </div>
                <div *ngIf="restricted" [ngClass]="{'hide-on-hover':(canEdit || canDelete) && (!readOnly)}" matTooltip="Restricted">
                    <mat-icon class="restricted">lock</mat-icon>
                </div>
                <!-- <div [ngClass]="{'display-on-hover':(canEdit || canDelete) && (!readOnly)}">
                    <button *ngIf="canEdit && (!readOnly)" mat-button aria-label="Edit Subject" class="mat-icon-button action-button" matTooltip="Edit" (click)="edit()">
                        <mat-icon class="edit">edit</mat-icon>
                    </button>
                    <button *ngIf="canDelete && (!readOnly)" mat-button aria-label="Remove Subject" class="mat-icon-button action-button" matTooltip="Remove" (click)="delete()">
                        <mat-icon class="delete">delete</mat-icon>
                    </button>
                </div> -->
                <div *ngIf="_subjectLink?.primary" [ngClass]="{'hide-on-hover':(canEdit || canDelete) && (!readOnly)}" style="margin-top: 6px;" matTooltip="Primary"><mat-icon class="star">star</mat-icon></div>
                
                <button mat-icon-button [matMenuTriggerFor]="moreMenu" 
                    aria-label="More" 
                    class="mat-icon-button" 
                    (click)="$event.stopPropagation()"
                    *ngIf="(canEdit || canDelete || ((!archived) && (allowEditRelationship && (possibleRelationships.length>0)))) && (!readOnly)" matTooltip="More">
                    <mat-icon>more_vert</mat-icon>
                </button> 
            </div>   
        </div>     
        <mat-menu #moreMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="relationships" *ngIf="(!archived) && allowEditRelationship && (possibleRelationships.length>0)">
                <mat-icon>edit</mat-icon>
                <span>Edit Relationship</span>
            </button>
            <button mat-menu-item aria-label="Edit subject" (click)="edit()" *ngIf="canEdit && (!archived) && (!readOnly)">
                <mat-icon>edit</mat-icon>
                <span>Edit {{_subjectLink?.linkedSubject?.subjectType?.name}}</span>
            </button>
            <button mat-menu-item aria-label="View subject" (click)="edit()" *ngIf="canEdit && (archived) && (!readOnly)">
                <mat-icon>open_in_new</mat-icon>
                <span>View {{_subjectLink?.linkedSubject?.subjectType?.name}}</span>
            </button>
            <button mat-menu-item aria-label="Remove" (click)="delete()" *ngIf="canDelete && ((!archived) || admin) && (!readOnly)">
                <mat-icon class="delete">delete</mat-icon>
                <span>Remove {{_subjectLink?.linkedSubject?.subjectType?.name}}</span>
            </button>
        </mat-menu>
        <mat-menu #relationships="matMenu">
            <button *ngFor="let item of possibleRelationships" mat-menu-item (click)="changeRelationship(_subjectLink, item)">{{item?.name}}</button>
        </mat-menu>
    </div>     
</div>
